<template>
  <div class="big-box" style=" cursor: pointer;">
    <div class="parent-Child" @click="submitButton(info.id)">
      <slot name="box-img">
        <img v-complete:src="info.image" alt="" />
      </slot>

      <div class="box-title">
        <!-- <slot name="boxP"> -->
        <p class="p1-research"> {{ dayjs(info.release_time * 1000).format("YYYY-MM-DD") }}</p>
        <p class="p2-research">
          {{ info.title }}
          <!-- 天利教育公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录知方公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录知方公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录 -->
        </p>
        <p class="p3-research" >
           {{ info.intro }}
          <!-- 时值仲春，见龙在田，2月21日，恰逢农历二月初二“龙抬头”，天利教育2023年答谢晚宴在北京金隅喜来登大酒店举行。 -->
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query:{id}
  });
}
</script>


<style scoped lang="scss">
.big-box {
  width: 343px;
  // border: 1px solid #d81717;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
}
.parent-Child {
  width: 100%;
  // border: 1px solid rgb(0, 157, 255);
  background-color: #ffffff;

  img {
    width: 100%;
    height: 201px;
    border-radius: 8px;
    display: block;
    // border: 1px solid red;
    margin-bottom: 12px;
  }

  .box-title {
    // position: relative;
    width:100%;
    // height:145px;
    // border:1px solid red;
    > .p1-research {
      height:22px;
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 16px;
    }
    > .p2-research {
      height: 48px;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;

      color: #333333;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 12px;
    }
    > .p3-research {
      height: 44px;
      line-height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;

      color: #666666;
      font-size: 12px;
      font-weight: 400;
      // margin-bottom: 18px;
    }

    .p2-research:hover,.p3-research:hover{
      color:#009de0;
    }
  }
}
</style>